import http from "@/http/aisea/axios";
const resource = "enterprises/crews/data/managements";

export default {
  // データ管理画面の構成を取得する
  fetchDataManagementDisplayConfigurations() {
    return http.get(`${resource}/display_configurations`);
  },

  // 直近の月締日を取得する
  fetchCurrentCutoffDate() {
    return http.get(`${resource}/manning_by_vessel_cutoff_date`);
  },
};
